/**
 * Update sorting data
 */

import { AAFieldItemSX, AAFormSelectSX } from '@/components/blocks/AddressForm/styles/formFields';
import { sort } from '@/components/content/CatalogEntryList/styles/sort';
import { useCatalogEntryList } from '@/data/Content/CatalogEntryList';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { ChevronRight } from '@mui/icons-material';
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useContext } from 'react';

export const CatalogEntryListSort: React.FC = () => {
	const { sortOptions, selectedSortOption, onSortOptionChange } = useContext(
		ContentContext
	) as ReturnType<typeof useCatalogEntryList>;
	const listSettingsNLS = useLocalization('CommerceEnvironment').listSettings;
	const ProductGrid = useLocalization('ProductGrid').Labels;

	return (
		<Grid item sm={12} md={3} sx={sort.mainContainer}>
			<FormControl fullWidth size="small" sx={AAFieldItemSX}>
				<InputLabel id="list-sort-option-label">{ProductGrid.sortBy.t()}</InputLabel>
				<Select
					labelId="list-sort-option-label"
					data-testid="list-sort-option"
					id="sortingSelector"
					name="listSort"
					label={ProductGrid.sortBy.t()}
					value={selectedSortOption}
					onChange={onSortOptionChange}
					IconComponent={ChevronRight}
					autoComplete="list-sort-option"
					fullWidth
					sx={AAFormSelectSX}
				>
					{sortOptions?.map((option) => (
						<MenuItem
							value={option.value}
							key={option.value}
							id={`productGrid_option_${option.value}`}
							data-testid={`productGrid_option_${option.value}`}
							className="sorting-option"
						>
							{listSettingsNLS[option.translationKey].t()}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Grid>
	);
};
